var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileLangSelectedIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "12.97 14 21.95 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1211 15.5488C34.9315 16.1775 35.1677 17.3803 34.6524 18.3073C30.6544 25.4994 27.0165 30.2848 24.8667 32.8462C23.7105 34.224 21.8513 34.4007 20.5402 33.1986C18.6684 31.4824 15.9174 28.5687 13.2848 24.3247C12.7887 23.5249 12.8961 22.4585 13.5144 21.7669L15.0996 19.9938C15.8376 19.1684 17.0507 19.1457 17.795 19.9644C20.4162 22.8478 22.4491 25.4624 22.4491 25.4624C22.4491 25.4624 25.4364 20.6058 30.0753 14.7174C30.7164 13.9035 31.8225 13.7659 32.6246 14.388L34.1211 15.5488Z",
    fill: "#CFA364"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLangSelectedIcon1);
export default __webpack_public_path__ + "static/media/mobileLangSelectedIcon1.c2ad223046b8892b7ccf18f160c56bca.svg";
export { ForwardRef as ReactComponent };